import * as React from "react";

/**
 * 3px gradient top accent for cards.
 * Uses border-image so it follows card border-radius clipping.
 */
const CardAccent = () => (
  <div
    style={{
      width: "100%",
      height: "3px",
      background: "linear-gradient(to right, #FFB500 0%, #FF5757 35%, #13A3E0 80%, #7ED956 100%)",
      borderRadius: "12px 12px 0 0",
      flexShrink: 0,
    }}
  />
);

export default CardAccent;
